import MultiMessageError from './MultiMessageError.js'

// Takes a function that returns a Foundation.Promise, and returns a native
// Promise.
export default function nativizeFoundationPromise (fn) {
  return new Promise((resolve, reject) => {
    try { var result = fn() }
    catch (err) { return reject(err) }

    if (result instanceof Promise) return resolve(result)

    return result
      .then(() => resolve(result))
      .otherwise(() => reject(new MultiMessageError(result.errors())))
  })
}
